var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 10.3333L14.1483 10.3333C13.7792 10.3333 13.4792 10.0342 13.4792 9.66417V1.33333C13.4792 0.596667 12.8825 0 12.1458 0L11.4792 0C10.7425 0 10.1458 0.596667 10.1458 1.33333V9.66417C10.1458 10.0333 9.84667 10.3333 9.47667 10.3333H1.33333C0.596667 10.3333 0 10.93 0 11.6667L0 12.3333C0 13.07 0.596667 13.6667 1.33333 13.6667H9.47667C9.84583 13.6667 10.1458 13.9658 10.1458 14.3358L10.1458 22.6667C10.1458 23.4033 10.7425 24 11.4792 24H12.1458C12.8825 24 13.4792 23.4033 13.4792 22.6667L13.4792 14.3358C13.4792 13.9667 13.7783 13.6667 14.1483 13.6667L22.6667 13.6667C23.4033 13.6667 24 13.07 24 12.3333V11.6667C24 10.93 23.4033 10.3333 22.6667 10.3333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon_add.593024f26cd1d2bce16a146ec31783ac.svg";
export { ForwardRef as ReactComponent };